import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../../context/CookieConsentContext';
import './CookieConsentBanner.css';

const CookieConsentBanner = () => {
  const {
    isBannerVisible,
    isPreferencesOpen,
    draftConsent,
    acceptAll,
    rejectNonEssential,
    savePreferences,
    openPreferences,
    closePreferences,
    updateDraftConsent,
  } = useCookieConsent();

  if (!isBannerVisible && !isPreferencesOpen) {
    return null;
  }

  return (
    <div className="cookie-consent-root" role="dialog" aria-modal="true" aria-labelledby="cookie-consent-title">
      <div className="cookie-consent-backdrop" onClick={isPreferencesOpen ? closePreferences : undefined} />

      <div className="cookie-consent-panel">
        {!isPreferencesOpen ? (
          <>
            <div className="cookie-consent-content">
              <h2 id="cookie-consent-title" className="cookie-consent-title">
                Usamos cookies
              </h2>
              <p className="cookie-consent-text">
                Utilizamos cookies propias y de terceros para el funcionamiento del sitio y analítica
                (Google Analytics) y, si lo aceptas, marketing. PostHog se usa con fines operativos
                del producto. Puedes aceptar todas, rechazar las no esenciales o personalizar tu elección.
                Más información en nuestra{' '}
                <Link to="/cookies/" className="cookie-consent-link">
                  política de cookies
                </Link>
                .
              </p>
            </div>

            <div className="cookie-consent-actions">
              <button type="button" className="cookie-consent-btn cookie-consent-btn-secondary" onClick={openPreferences}>
                Personalizar
              </button>
              <button type="button" className="cookie-consent-btn cookie-consent-btn-secondary" onClick={rejectNonEssential}>
                Rechazar no esenciales
              </button>
              <button type="button" className="cookie-consent-btn cookie-consent-btn-primary" onClick={acceptAll}>
                Aceptar todas
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="cookie-consent-content">
              <h2 id="cookie-consent-title" className="cookie-consent-title">
                Preferencias de cookies
              </h2>
              <p className="cookie-consent-text">
                Elige qué categorías de cookies quieres permitir. Las cookies esenciales son necesarias
                para el funcionamiento básico del sitio.
              </p>

              <div className="cookie-consent-categories">
                <div className="cookie-consent-category">
                  <div className="cookie-consent-category-header">
                    <strong>Esenciales</strong>
                    <span className="cookie-consent-badge">Siempre activas</span>
                  </div>
                  <p>Necesarias para la seguridad, sesión y funciones básicas del sitio.</p>
                </div>

                <label className="cookie-consent-category cookie-consent-category-toggle">
                  <div className="cookie-consent-category-header">
                    <strong>Analíticas</strong>
                    <input
                      type="checkbox"
                      checked={draftConsent.analytics}
                      onChange={(event) => updateDraftConsent('analytics', event.target.checked)}
                    />
                  </div>
                  <p>Google Analytics y medición de uso web para mejorar el producto.</p>
                </label>

                <label className="cookie-consent-category cookie-consent-category-toggle">
                  <div className="cookie-consent-category-header">
                    <strong>Marketing</strong>
                    <input
                      type="checkbox"
                      checked={draftConsent.marketing}
                      onChange={(event) => updateDraftConsent('marketing', event.target.checked)}
                    />
                  </div>
                  <p>Publicidad, remarketing y seguimiento de campañas.</p>
                </label>
              </div>
            </div>

            <div className="cookie-consent-actions">
              <button type="button" className="cookie-consent-btn cookie-consent-btn-secondary" onClick={closePreferences}>
                Cancelar
              </button>
              <button type="button" className="cookie-consent-btn cookie-consent-btn-primary" onClick={savePreferences}>
                Guardar preferencias
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CookieConsentBanner;
